const cache: Record<string, { timestamp: number; data: unknown }> = {};

const CACHE_DURATION = 5 * 60 * 1000; // 5 минут в миллисекундах

export const getCachedData = (key: string) => {
  const cached = cache[key];
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.data;
  }
  return null;
};

export const setCachedData = (key: string, data: unknown) => {
  cache[key] = { timestamp: Date.now(), data };
};

export const resetCachedData = () => {
  Object.keys(cache).forEach((key) => {
    delete cache[key];
  });
};
